webpackJsonp([7,35],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(58),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'boNumber',
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 9999
	    },
	    min: {
	      type: Number,
	      default: 0
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    getOldValue: function getOldValue() {
	      return this.valueSelf;
	    },
	    plus: function plus() {
	      if (this.valueSelf < this.max) {
	        this.valueSelf = this.valueSelf - 0 + 1;
	        this.$emit('on-change', this.valueSelf);
	        this.$emit('input', this.valueSelf);
	      } else {
	        this.$emit('on-max', this.valueSelf);
	      }
	    },
	    sub: function sub() {
	      if (this.valueSelf >= 1 && this.valueSelf > this.min) {
	        this.valueSelf -= 1;
	        this.$emit('on-change', this.valueSelf);
	        this.$emit('input', this.valueSelf);
	      } else {
	        this.$emit('on-min', this.valueSelf);
	      }
	    },
	    setBtn: function setBtn(params) {
	      if (params.right) {
	        this.rightBtnState = params.right;
	      }
	      if (params.left) {
	        this.leftBtnState = params.left;
	      }
	    },
	    rollback: function rollback() {
	      this.valueSelf = this.valueOld;
	    },
	    fresh: function fresh(val) {
	      console.log('fresh');
	
	      var newVal = val || this.valueSelf;
	
	      if (this.valueSelf < this.min) {
	        this.valueSelf = this.min;
	      }
	      if (this.valueSelf > this.max) {
	        this.valueSelf = this.max;
	      }
	      if (this.valueSelf === 0) {
	        this.setBtn({
	          left: 'hidden'
	        });
	      }
	
	      if (newVal >= this.max) {
	        this.setBtn({
	          right: 'disable'
	        });
	        this.setBtn({
	          left: 'active'
	        });
	      } else if (newVal <= this.min) {
	        this.setBtn({
	          right: 'active'
	        });
	        this.setBtn({
	          left: 'hidden'
	        });
	      } else {
	        this.setBtn({
	          right: 'active'
	        });
	        this.setBtn({
	          left: 'active'
	        });
	      }
	    }
	  },
	  created: function created() {
	    this.fresh();
	  },
	
	  watch: {
	    max: function max() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.fresh();
	      }, 1);
	    },
	    min: function min() {
	      this.fresh();
	    },
	    valueSelf: function valueSelf(newVal, oldVal) {
	      this.valueOld = oldVal;
	      this.fresh(newVal);
	    },
	    value: function value(newval) {
	      this.valueSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      valueOld: this.value,
	      leftBtnState: 'active',
	      rightBtnState: 'active'
	    };
	  }
	};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex-box number"
	  }, [_c('div', {
	    staticClass: "flex-item"
	  }, [_c('button', {
	    class: ['btn-icon', 'number-btn-' + this.leftBtnState],
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.sub
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-jian-xianxingyuankuang"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item-1"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    class: ['number-input', 'flex-item-1', _vm.valueSelf == 0 ? 'number-input-hidden' : ''],
	    attrs: {
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item"
	  }, [_c('button', {
	    class: ['btn-icon', 'number-btn-' + this.rightBtnState],
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.plus
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-jia-yuankuang"
	  })])])])
	},staticRenderFns: []}

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      default: ''
	    },
	    content: {
	      default: ''
	    },
	    image: {
	      default: ''
	    },
	
	    limit: {
	      type: Number,
	      default: 0
	    },
	
	    stock: {
	      type: Number,
	      default: -1
	    },
	    amount: {
	      type: Number,
	      default: 0
	    },
	    tip: {
	      default: ''
	    },
	    flag: {
	      default: ''
	    },
	    price: {
	      type: Number,
	      default: 0
	    },
	    oldprice: {
	      type: Number,
	      default: 0
	    },
	    priceUnit: {
	      default: ''
	    },
	    pricePreUnit: {
	      default: '¥'
	    },
	    unit: {
	      default: ''
	    },
	
	    ratio: {
	      default: 1
	    },
	
	    surface: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	
	    canbuy: {
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      amountSelf: this.amount,
	      imgHeight: 80
	    };
	  },
	
	  computed: {
	    max: function max() {
	      var leftStock = parseFloat(this.stock);
	      var perlim = parseFloat(this.limit);
	      if (perlim == 0) {
	        return leftStock;
	      }
	      return perlim > leftStock ? leftStock : perlim;
	    }
	  },
	  mounted: function mounted() {
	    this.imgHeight = this.$refs.img.offsetWidth * this.ratio;
	  },
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick() {
	      this.$emit('on-click', this);
	    },
	    buy: function buy(amount) {
	      this.amountSelf = amount;
	      if (amount === 0) {
	        this.$emit('on-delete', this);
	      } else if (amount === this.max) {
	        this.$emit('on-limit', this);
	        this.$emit('on-buy', this);
	      } else {
	        this.$emit('on-buy', this);
	      }
	    }
	  },
	  components: {}
	};

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(160),
	  /* template */
	  __webpack_require__(244),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _product = __webpack_require__(217);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productSingle = __webpack_require__(216);
	
	var _productSingle2 = _interopRequireDefault(_productSingle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    product: _product2.default,
	    productSingle: _productSingle2.default
	  },
	  created: function created() {},
	
	  methods: {
	    toast: function toast(msg) {
	      this.$toast.open(msg);
	    }
	  },
	  data: function data() {
	    return {
	      data: [{
	        name: '绝味饼干',
	        tip: '限购',
	        image: 'http://pic02.keyinong.com/product/pic/20171018150835_29785.jpg?imageView2/1/w/200/h/200',
	        limit: 10,
	        stock: 10,
	        price: 10,
	        amount: 0
	      }, {
	        name: '美味蛋糕',
	        content: '非常好吃的饼干哦~~',
	        image: 'http://pic02.keyinong.com/product/pic/20171018151330_64818.jpg?imageView2/1/w/200/h/200',
	        limit: 10,
	        stock: 10,
	        price: 10,
	        amount: 1,
	        flag: '剩余10件'
	      }, {
	        name: '红纱鸡肉',
	        content: '吃得让你流连忘返',
	        image: 'http://pic02.keyinong.com/product/pic/20171018145531_77564.jpg?imageView2/1/w/200/h/200',
	        limit: 10,
	        stock: 0,
	        price: 10,
	        amount: 1
	      }, {
	        name: '美味的栗子美味的栗子美味的栗子美味的栗子美味的栗子美味的栗子',
	        content: '激发活力无限',
	        image: 'http://pic02.keyinong.com/product/pic/20171018145224_68398.jpg?imageView2/1/w/200/h/200',
	        limit: 5,
	        stock: 10,
	        price: 1000000000000,
	        amount: 5
	      }]
	    };
	  }
	};

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boNumber = __webpack_require__(42);
	
	var _boNumber2 = _interopRequireDefault(_boNumber);
	
	var _core = __webpack_require__(59);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  extends: _core2.default,
	  components: {
	    BoNumber: _boNumber2.default
	  }
	};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boNumber = __webpack_require__(42);
	
	var _boNumber2 = _interopRequireDefault(_boNumber);
	
	var _core = __webpack_require__(59);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  extends: _core2.default,
	  components: {
	    BoNumber: _boNumber2.default
	  }
	};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(161),
	  /* template */
	  __webpack_require__(268),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(162),
	  /* template */
	  __webpack_require__(226),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card card-square product",
	    staticStyle: {
	      "border": "0"
	    }
	  }, [_c('div', {
	    ref: "img",
	    staticClass: "product-img",
	    style: ({
	      backgroundImage: ("url(" + _vm.image + ")"),
	      height: (_vm.imgHeight + "px")
	    }),
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.flag !== '') ? _c('span', {
	    staticClass: "product-flag"
	  }, [_vm._v(_vm._s(_vm.flag))]) : _vm._e()]), _vm._v(" "), _c('h3', {
	    staticClass: "tl product-title m1000",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n    "), (_vm.tip !== '') ? _c('span', {
	    staticClass: "product-tip"
	  }, [_vm._v("\n      " + _vm._s(_vm.tip) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "product-intro"
	  }, [_c('p', {
	    staticClass: "product-content tl p0010"
	  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), (_vm.oldprice > 0 && _vm.oldprice != _vm.price) ? _c('p', {
	    staticClass: "product-content tl",
	    staticStyle: {
	      "text-decoration": "line-through"
	    }
	  }, [_vm._v("\n      原价 " + _vm._s(_vm.oldprice) + " " + _vm._s(_vm.priceUnit) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "flex-box tl product-dock",
	    staticStyle: {
	      "align-self": "flex-end"
	    }
	  }, [_c('div', {
	    staticClass: "flex-item-1 color-highlight font-md",
	    staticStyle: {
	      "white-space": "nowrap"
	    }
	  }, [_c('span', {
	    staticClass: "font-sm"
	  }, [_vm._v(_vm._s(_vm.pricePreUnit))]), _vm._v(" " + _vm._s(_vm.price) + "\n      "), (_vm.priceUnit !== '') ? _c('span', {
	    staticClass: "price-unit"
	  }, [_vm._v(_vm._s(_vm.priceUnit))]) : _vm._e()]), _vm._v(" "), (_vm.canbuy) ? _c('div', {
	    staticClass: "flex-item",
	    staticStyle: {
	      "padding-top": "2px"
	    }
	  }, [_c('div', {
	    staticClass: "flex-box number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [(_vm.stock > 0) ? _c('bo-number', {
	    ref: "number",
	    attrs: {
	      "max": _vm.max,
	      "value": _vm.amountSelf
	    },
	    on: {
	      "on-change": _vm.buy
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.stock <= 0) ? _c('span', {
	    staticClass: "font-light font-sm p1000",
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._v("库存不足")]) : _vm._e()]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('ul', {
	    staticClass: "list-hack p1111 card card-square ovf"
	  }, _vm._l((_vm.data), function(item) {
	    return _c('li', {
	      staticClass: "p1111",
	      staticStyle: {
	        "width": "50%",
	        "float": "left"
	      }
	    }, [_c('product', {
	      attrs: {
	        "name": item.name,
	        "content": item.content,
	        "image": item.image,
	        "tip": item.tip,
	        "limit": item.limit,
	        "stock": item.stock,
	        "amount": item.amount,
	        "flag": item.flag,
	        "ratio": "0.9"
	      },
	      on: {
	        "on-click": function($event) {
	          _vm.toast('点击详情')
	        },
	        "on-delete": function($event) {
	          _vm.toast('商品归零')
	        },
	        "on-limit": function($event) {
	          _vm.toast('达到上限')
	        },
	        "on-buy": function($event) {
	          _vm.toast('购买')
	        }
	      }
	    })], 1)
	  })), _vm._v(" "), _c('ul', {
	    staticClass: "list-hack p2222 m2000 card card-square ovf"
	  }, _vm._l((_vm.data), function(item) {
	    return _c('li', [_c('product-single', {
	      attrs: {
	        "name": item.name,
	        "content": item.content,
	        "image": item.image,
	        "tip": item.tip,
	        "limit": item.limit,
	        "stock": item.stock,
	        "amount": item.amount,
	        "flag": item.flag,
	        "price": item.price,
	        "ratio": "0.9"
	      },
	      on: {
	        "on-click": function($event) {
	          _vm.toast('点击详情')
	        },
	        "on-delete": function($event) {
	          _vm.toast('商品归零')
	        },
	        "on-limit": function($event) {
	          _vm.toast('达到上限')
	        },
	        "on-buy": function($event) {
	          _vm.toast('购买')
	        }
	      }
	    })], 1)
	  }))])
	},staticRenderFns: []}

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card card-square rbb product product-single",
	    staticStyle: {
	      "border": "0"
	    }
	  }, [_c('div', {
	    staticClass: "flex-box p2020"
	  }, [_c('div', {
	    staticClass: "flex-item",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('div', {
	    ref: "img",
	    staticClass: "product-img",
	    style: ({
	      backgroundImage: ("url(" + _vm.image + ")"),
	      height: (_vm.imgHeight + "px")
	    }),
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.flag !== '') ? _c('span', {
	    staticClass: "product-flag"
	  }, [_vm._v(_vm._s(_vm.flag))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item-1 tl p0001 product-info"
	  }, [_c('h3', {
	    staticClass: "font-md tl product-title",
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n        "), (_vm.tip !== '') ? _c('span', {
	    staticClass: "product-tip"
	  }, [_vm._v("\n          " + _vm._s(_vm.tip) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "product-intro"
	  }, [_c('p', {
	    staticClass: "f-light font-sm"
	  }, [_vm._v("\n        " + _vm._s(_vm.content) + "\n      ")]), _vm._v(" "), (_vm.oldprice > 0 && _vm.oldprice != _vm.price) ? _c('p', {
	    staticClass: "f-light font-sm",
	    staticStyle: {
	      "text-decoration": "line-through"
	    }
	  }, [_vm._v("\n        原价 " + _vm._s(_vm.pricePreUnit) + " " + _vm._s(_vm.oldprice) + " " + _vm._s(_vm.priceUnit) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "flex-box tl product-dock p0001"
	  }, [_c('div', {
	    staticClass: "flex-item-1 color-highlight",
	    staticStyle: {
	      "font-size": "16px",
	      "white-space": "nowrap"
	    }
	  }, [_c('span', {
	    staticClass: "font-sm"
	  }, [_vm._v(_vm._s(_vm.pricePreUnit))]), _vm._v(" " + _vm._s(_vm.price)), _c('span', {
	    staticClass: "price-unit"
	  }, [_vm._v(" " + _vm._s(_vm.priceUnit))])]), _vm._v(" "), (_vm.canbuy) ? _c('div', {
	    staticClass: "flex-item"
	  }, [_c('div', {
	    staticClass: "flex-box number",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [(_vm.stock > 0) ? _c('bo-number', {
	    ref: "number",
	    attrs: {
	      "max": _vm.max,
	      "value": _vm.amount
	    },
	    on: {
	      "on-change": _vm.buy
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.stock <= 0) ? _c('span', {
	    staticClass: "font-light font-sm p1000",
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._v("库存不足")]) : _vm._e()]) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.0c12b403442382a8e601.js